<lm-modal-header> 
        <span class="text-base font-semibold">{{ title }}</span> 
</lm-modal-header>
<lm-modal-content> 
        <div class="min-h-[50px] px-6 whitespace-pre-line mb-[25px]">{{ description }}</div>
</lm-modal-content>